import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'no-wallet',
    templateUrl: './no-wallet.component.html',
    styleUrls: ['./no-wallet.component.scss'],
    standalone: false
})
export class NoWalletComponent implements OnInit {

  ngOnInit() {
  }
}
